import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getAllBots = (limit, lastTime, callback) => {
  return async (dispatch) => {
    if (lastTime) {
      dispatch({
        type: 'GETTING_ALL_BOTS_WITH_PAGINATION',
      });
    } else {
      dispatch({ type: 'GETTING_ALL_BOTS' });
    }
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/bots`, {
            params: {
              'request-id': reqId,
              limit: limit,
              lastSeen: lastTime,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            if (lastTime) {
              await dispatch({
                type: 'ADD_BOTS_TO_ALL_BOTS',
                payload: {
                  bots: response?.data || [],
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            } else {
              await dispatch({
                type: 'GETTING_ALL_BOTS_DONE',
                payload: {
                  bots: response?.data || [],
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            }
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_ALL_BOTS_FAILED',
              payload: `Failed to fetch bots`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_ALL_BOTS_FAILED',
            payload: `Failed to fetch bots`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GETTING_ALL_BOTS_FAILED',
        payload: `Failed to fetch bots`,
      });
    }
  };
};

export default getAllBots;
